import {Incident} from "@/lib/types/statuspages.ts";
import {parseISO} from "date-fns/parseISO";

export type SortOptions =
  | "most_recently_updated"
  | "most_recently_created"
  | "longest_duration"
  | "shortest_duration"
  | "upcoming_first"
  | "upcoming_last";

export const INCIDENTS_SORT_OPTIONS: {value: SortOptions; label: string}[] = [
  {value: "most_recently_updated", label: "Most Recently Updated"},
  {value: "most_recently_created", label: "Most Recently Created"},
  {value: "longest_duration", label: "Longest Duration"},
  {value: "shortest_duration", label: "Shortest Duration"},
];

export const SCHEDULED_MAINTENANCE_SORT_OPTIONS: {value: SortOptions; label: string}[] = [
  {value: "most_recently_updated", label: "Most Recently Updated"},
  {value: "most_recently_created", label: "Most Recently Created"},
  {value: "upcoming_first", label: "Upcoming First"},
  {value: "upcoming_last", label: "Upcoming Last"},
];

export const sortIncidents = (incidents: Incident[], sortBy: SortOptions): Incident[] => {
  const sorted = [...incidents];

  switch (sortBy) {
    case "most_recently_updated":
      return sorted.sort((a, b) => {
        const dateA = a.updates?.[0]?.updated_at || a.starts_at;
        const dateB = b.updates?.[0]?.updated_at || b.starts_at;
        return parseISO(dateB).getTime() - parseISO(dateA).getTime();
      });

    case "most_recently_created":
      return sorted.sort((a, b) => {
        return parseISO(b.starts_at).getTime() - parseISO(a.starts_at).getTime();
      });

    case "longest_duration":
      return sorted.sort((a, b) => b.duration - a.duration);

    case "shortest_duration":
      return sorted.sort((a, b) => a.duration - b.duration);

    case "upcoming_first":
      return sorted.sort((a, b) => parseISO(a.starts_at).getTime() - parseISO(b.starts_at).getTime());

    case "upcoming_last":
      return sorted.sort((a, b) => parseISO(b.starts_at).getTime() - parseISO(a.starts_at).getTime());

    default:
      return sorted;
  }
};
